import API from "../../services/api";
import { downloadPayslip, getPayslipData } from "../payroll/payrollApi";

export { downloadPayslip, getPayslipData };

/** Month-labelled payroll runs available for payslip preview/download. */
export async function fetchPayslipRunOptions(employeeId) {
  const res = await API.get("/payslip/available-runs", {
    params: { employee_id: employeeId },
  });
  return Array.isArray(res.data) ? res.data : [];
}

/** Employee self-service: pay months for the signed-in employee only. */
export async function fetchMyPayslipRunOptions() {
  const res = await API.get("/payslip/me/available-runs");
  return Array.isArray(res.data) ? res.data : [];
}
